import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NONE_TYPE } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { catchError, Observable, repeat, shareReplay, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private http: HttpClient,
    public authenticationService: AuthenticationService
  ) {}

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getAPI<Type>(
    endpoint: string,
    queryParams?: any,
    pollInterval?: number
  ): Observable<any> {
    let parameters = {};
    if (pollInterval) {
      if (queryParams) {
        parameters = queryParams;
      }
      // fixme: this is only temporary, need to find a better way to do this
      return this.http
        .get<Type>(`${environment.apiUrl}/${endpoint}`, {
          observe: 'response',
          responseType: 'json',
          params: parameters,
        })
        .pipe(
          catchError(this.handleError),
          // shareReplay(),
          repeat({ delay: pollInterval })
          // repeat({ delay: pollInterval, count: 1 })
        );
    } else {
      if (queryParams) {
        parameters = queryParams;
      }
      return this.http
        .get<Type>(`${environment.apiUrl}/${endpoint}`, {
          observe: 'response',
          responseType: 'json',
          params: parameters,
        })
        .pipe(catchError(this.handleError), shareReplay(1));
    }
  }

  postAPI<Type>(endpoint: string, data: any, object?: any): Observable<any> {
    return this.http
      .post<Type>(`${environment.apiUrl}/${endpoint}`, data, {
        observe: 'response',
        responseType: 'json',
      })
      .pipe(catchError(this.handleError));
  }

  postWebhookAPI<Type>(
    endpoint: string,
    data: any,
    options?: {
      observe?: 'body' | 'events' | 'response';
      reportProgress?: boolean;
      responseType?: 'json';
    }
  ): Observable<any> {
  
    const url = `${environment.apiUrl}/${endpoint}`;
  
    if (options?.observe === 'events') {
      return this.http.post<Type>(url, data, {
        observe: 'events',
        reportProgress: options.reportProgress ?? false,
        responseType: 'json',
      }).pipe(catchError(this.handleError));
    }
  
    if (options?.observe === 'response') {
      return this.http.post<Type>(url, data, {
        observe: 'response',
        responseType: 'json',
      }).pipe(catchError(this.handleError));
    }
  
    // default: body
    return this.http.post<Type>(url, data, {
      observe: 'body',
      responseType: 'json',
    }).pipe(catchError(this.handleError));
  }
  

  postFileAPI<Type>(endpoint: string, data: any): Observable<any> {
    return this.http
      .post<Type>(`${environment.apiUrl}/${endpoint}`, data, {
        observe: 'response',
        responseType: 'json',
      })
      .pipe(catchError(this.handleError));
  }

  deleteAPI<Type>(endpoint: string, query_id: Number): Observable<any> {
    return this.http
      .delete<Type>(`${environment.apiUrl}/${endpoint}/${query_id}`, {
        observe: 'response',
        responseType: 'json',
      })
      .pipe(catchError(this.handleError));
  }

  updateAPI<Type>(
    endpoint: string,
    query_id?: number,
    data?: any
  ): Observable<any> {
    if (!query_id && !data) {
      return this.http
        .patch<Type>(`${environment.apiUrl}/${endpoint}`, {
          observe: 'response',
          responseType: 'json',
        })
        .pipe(catchError(this.handleError));
    } else {
      return this.http
        .put<Type>(`${environment.apiUrl}/${endpoint}/${query_id}`, data, {
          observe: 'response',
          responseType: 'json',
        })
        .pipe(catchError(this.handleError));
    }
  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    if (error.status === 401) {
      // window.alert(errorMessage);
    } else {
      // window.alert(errorMessage);
    }

    return throwError(() => {
      return errorMessage;
    });
  }

  getFileAPI(endpoint: string, params?: any) {
    const url = `${environment.apiUrl}/${endpoint}`;

    return this.http
      .get(url, {
        params: params,
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(catchError(this.handleError));
  }

  getExcelFileAPI(endpoint: string, queryParams?: any) {
    let parameters = {};
    if (queryParams) {
      parameters = queryParams;
    }
    return this.http
      .get(`${environment.apiUrl}/${endpoint}`, {
        observe: 'response',
        responseType: 'blob',
        params: parameters,
      })
      .pipe(catchError(this.handleError));
  }
}
